import React, { Component } from "react";
import { Grid, Icon, Loader, Responsive, Checkbox, Button, Dimmer, Menu, Dropdown, Popup, Confirm, Image } from "semantic-ui-react";
import moment from "moment";
import {
	getLabAppointmentsBetweenDates,
	postLabAppointment,
	patchLabAppointment,
	deleteLabAppointment,
	resetLabAppointmentList,
} from "services/labAppointment";
import { addPayment, casingPaymentCancel } from "services/payment";
import { getMatchingAnalyses } from "services/analysisLibrary";
import { getSafePlaceAppointment, useSafePlaceQR, cancelSafePlaceQR, qrSearch } from "services/safeplace";
import {
	searchPatientsMyLab,
	postPatient,
	getPatientMyLab,
	getMatchingPatient,
	patchPatient,
	postPatientMyLab,
	getMpiPatientByMatricule,
	getInvoicesForPatient,
	getCasingForPatient,
	cancelCasingForPatient,
	exportCasingForPatient,
	resetInvoicesForPatient,
} from "services/patient";
import { getDepositPlaces, getDepositSamplers } from "services/deposit";
import { getDoctorExists, postDoctor, patchDoctor, searchDoctors } from "services/doctor";
import {
	getPrescriptionByBarcode,
	postPrescription,
	postScanPrescription,
	bulkAnalysesPrescription,
	getEPrescription,
	getAllPrescriptionScans,
} from "services/prescription";
import {
	setFocusedFolders,
	getPatientExistingFolder,
	openFolder,
	getPatientClosedFolders,
	changePatient,
	postExpress,
	associateCenterAppointmentWithFolder,
} from "services/folder";
import { setFilters, setTab } from "services/foldersOverview";
import { getAllDocumentTypes } from "services/documentType";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import MainButton from "components/Buttons/MainButton";
import AddPatient from "./components/Sidebar/AddPatient";
import { displayGender } from "utils/displayGender";
import displayName from "utils/displayName";
import { asyncForEach } from "utils/asyncForEach";
import SearchInput from "features/Lab/components/SearchInput";
import SecondaryBlueButton from "components/Buttons/SecondaryBlueButton";
import { toast } from "react-toastify";
import QRReaderPrescriptionModal from "./components/QRReaderPrescriptionModal";
import AddNurseHelpModal from "features/FolderManager/components/modals/AddNurseHelpModal";
import {
	convertPatientToMyLab,
	convertMyLabToPatient,
	convertSafePlaceResultToPatient,
	convertForPatientMatcher,
	convertSafeplacePatientToMyLab,
	convertPreregisterResultToPatient,
} from "utils/patientConverter";
import { ServiceEnum } from "config/service";
import DatePicker from "react-datepicker";
import { getAllSpecialRegimes } from "services/specialRegime";
import "react-datepicker/dist/react-datepicker.css";
import ReopenFolderModal from "./components/modals/ReopenFolderModal";
import IdentitoVigilanceModal from "./components/modals/IdentitoVigilanceModal";
import PatientMatchingModal from "./components/modals/PatientMatchingModal";
import CustomPagination from "components/CustomPagination";
import { checkPrefixePhoneNumer } from "utils/phone";
import { getMyOpenedFolders, getFoldersWaitingTubes, getFoldersWaitingAliquots, searchFolderWithTube } from "services/folder";
import { getAssignedToMeFolderHelp, doneFolderHelp, cancelFolderHelp, notifyMeForPreregister } from "services/folderHelp";
import { b64toFile, getFileType } from "utils/file";
import { sendPatientToDualScreen } from "services/dualScreen";
import { withTranslation } from "react-i18next";
import { editPIQuestionAnswer } from "services/questionAnswer";
import { createFolderHelp, getSecretariesActive } from "services/folderHelp";
import { setBusyBox } from "services/live";
import FoldersList from "./components/FoldersList";
import { qrPreregister, getPreregisterAppointment, postPreregisterForceStatusUrgent, postCheckin, getCheckinsForPatient } from "services/preregister";
import RepetitiveCalls from "./components/RepetitiveCalls";
import { getCampaignResultByQrCode, qrSearchCampaign } from "services/campaign";
import URLOrdoMyLab from "./components/URLOrdoMyLab";
import ExpressDepositModal from "./components/modals/ExpressDepositModal";
import { getAnalysesPacksForDeposits } from "services/analysesPack";
import CasingPaymentModal from "./components/modals/CasingPaymentModal";
import CheckinModal from "./components/modals/CheckinModal";

const isMobile = () => {
	return window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
};

const styles = {
	containerStyle: { paddingTop: isMobile() ? 0 : 30 },
	roundHeaderContainer: {
		height: isMobile() ? "initial" : "100%",
		backgroundColor: "#43b39e",
		width: "100%",
		padding: 10,
		display: "flex",
		flexWrap: "wrap",
		borderRadius: "4px 4px 0 0",
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		position: "relative",
		fontSize: "0.9em",
	},
	columnFlex: { display: isMobile() ? "contents" : "flex", height: isMobile() ? "initial" : "100%", alignItems: "center" },
	icon: { color: "#fff", fontSize: "1.5em" },
	dateText: { color: "white", marginRight: 5, marginLeft: 5 },
	nombreItem: { display: "inline-flex" },
	nombreItemLabel: {
		color: "white",
		marginRight: "4px",
		fontSize: "0.8em",
		padding: "6px",
	},
	nombreItemMenu: { padding: "5px", height: "auto", fontSize: "0.8em" },
	searchFolders: {
		backgroundColor: "transparent",
		width: "100%",
		padding: "0.5em",
		border: "1px solid white",
		color: "white",
		borderRadius: "4px",
		height: "95%",
	},
	searchFoldersIcon: { top: "7px", right: "12px", color: "white" },
};

const _appointmentContainer = (status, shouldOpen, urgent) => ({
	backgroundColor:
		status === "DONE"
			? "rgba(66, 179, 158, 0.4)"
			: status === "CANCELED"
			? "rgba(145,166,180, 0.4)"
			: urgent
			? "rgba(255, 80, 77,0.4)"
			: shouldOpen
			? "rgba(253, 253, 150,0.4)"
			: "#fff",
	width: "100%",
	position: "relative",
	padding: 10,
	display: "flex",
	borderRadius: "0",
	marginTop: "5px",
	boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
	alignItems: "center",
});

class FoldersOverview extends Component {
	constructor(props) {
		props.resetLabAppointmentList();
		super(props);

		this.timeout = 0;
		this.folderTimeout = 0;
		this.state = {
			folderSelection: new Set([]),
			openFolderManager: false,
			currentFilterSearch: "",
			currentFolderFilterSearch: "",
			patientPaging: 1,
			patientNbItems: 50,
			QRReaderPrescriptionModal: false,
			QRReaderSafePlaceModal: false,
			QRReaderCnsModal: false,
			prescriptionIsLoading: false,
			searchStarted: false,
			hasCameraAccess: false,
			reopenFolderModalOpen: false,
			optionsSize: [],
			patientMatcher: null,
			safeplaceMpi: null,
			safeplaceDsp: null,
			safeplaceMyLab: null,
			safeplaceMyLabList: [],
			safeplaceLarger: false,
			safeplacePage: 1,
			safeplaceCode: "",
			preregisterCode: "",
			identitoVigilanceModal: false,
			identitoVigilancePatient: {},
			displayLargerSearch: false,
			openAddNurseHelpModal: false,
			addNurseHelpModalFolder: {},
			hideList: false,
			tvsec: false,
			deposit: false,
			isCampaign: false,
			campaign: null,
			preregister: null,
			safeplace: null,
			eprescriptionMyLab: null,
			ePrescriptionAgence: null,
			expressDepositModal: false,
			paymentPatient: null,
			paymentModal: false,
			confirmCloseCasingPaymentModal: false,
			centerAppointmentId: null,
			checkinModal: false,
			checkinPatient: null,
		};
	}

	componentDidMount() {
		this.mounted = true;
		let { startDate, endDate, showDone, page, search, size, centers, box } = this.props.foldersOverview.filters;
		this.getFolders(startDate, endDate, showDone, page, search, size, centers, box);
		this.setState({ currentFolderFilterSearch: search });
		this.props.getAllSpecialRegimes();
		if (!this.props.documentTypes || !this.props.documentTypes.list || this.props.documentTypes.list.length === 0) this.props.getAllDocumentTypes();
		if (this.props.safeplaceQR) {
			this.submitQRReaderSafePlaceModal(this.props.safeplaceQR);
			this.props.qrSearch(null);
		}
		if (this.props.campaignQR) {
			this.submitQRReaderCampaignModal(this.props.campaignQR);
			this.props.qrSearchCampaign(null);
		}
		if (this.props.preregister.preregisterQR) {
			this.submitQRReaderPreregisterModal(this.props.preregister.preregisterQR.qr_code);
			this.props.qrPreregister(null);
		}
		this.props.getSecretariesActive();
		this.props.getDepositPlaces();
		this.props.getDepositSamplers();
	}

	componentDidUpdate(prevProps, prevContext) {
		if (prevProps.labAppointment.list !== this.props.labAppointment.list) {
			this.getColorPriorityAnalyses(this.props.labAppointment.list).then((res) => {
				this.forceUpdate();
			});
		}
		if (this.props.preregister.preregisterQR && prevProps.preregister.preregisterQR !== this.props.preregister.preregisterQR) {
			this.submitQRReaderPreregisterModal(this.props.preregister.preregisterQR);
			this.props.qrPreregister(null);
		}
	}

	componentWillUnmount() {
		//Reset search input text
		this.props.setFilters(new Date(), new Date(), null, null, "", null, null, null);

		this.mounted = false;
	}

	getFolders = async (date1, date2, done, p, folderSearch, sizePage, allCenters, myBox = null) => {
		if (date1) date1 = moment(date1).format("YYYY-MM-DD");
		if (date2) date2 = moment(date2).format("YYYY-MM-DD");
		await this.props.setFilters(date1, date2, done, p, folderSearch, sizePage, allCenters, myBox);
		const { startDate, endDate, showDone, page, search, centers, box } = this.props.foldersOverview.filters;
		const { size } = this.props.foldersOverview;

		await this.props.getLabAppointmentsBetweenDates(
			startDate,
			endDate,
			this.props.user.session.center.id,
			showDone,
			search,
			page,
			size,
			centers,
			box,
			this.props.user.session.box ? this.props.user.session.box.id : 0
		);
		if (page !== this.props.labAppointment.page) {
			toast.warning(`La page ${page} n'existe pas`);
			await this.props.setFilters(date1, date2, done, this.props.labAppointment.page, folderSearch, sizePage, allCenters, myBox);
		}
		this.getOptionsSize();
	};

	toggleHideList = () => {
		this.setState({ hideList: !this.state.hideList });
	};

	refreshFolders = async () => {
		const { startDate, endDate, showDone, page, search, centers, box } = this.props.foldersOverview.filters;
		const { size } = this.props.foldersOverview;
		await this.props.getLabAppointmentsBetweenDates(
			startDate,
			endDate,
			this.props.user.session.center.id,
			showDone,
			search,
			page,
			size,
			centers,
			box,
			this.props.user.session.box ? this.props.user.session.box.id : 0
		);
	};

	searchPatientsPage = (page) => {
		this.searchPatients(page);
		this.mounted && this.setState({ patientPaging: page });
	};
	searchPatients = (page) => {
		this.mounted && this.setState({ patientPaging: page, displayLargerSearch: false });
		const { patientNbItems, currentFilterSearch } = this.state;
		let data = { multiple_search: currentFilterSearch };
		this.props.searchPatientsMyLab(data, patientNbItems, (page - 1) * patientNbItems);
	};
	searchFolderWithTube = () => {
		this.props.searchFolderWithTube(this.state.currentFilterSearch).then((res) => {
			if (res.payload.data && res.payload.data.length === 1) {
				this.selectFolder(res.payload.data[0].id);
				this.goToFolderManager();
			}
		});
	};

	changeFilterInput = (value) => {
		if (this.timeout) clearTimeout(this.timeout);
		this.mounted && this.setState({ searchStarted: false });
		if (value !== this.state.currentFilterSearch) {
			this.mounted && this.setState({ currentFilterSearch: value });
		}
		// Trigger the search after the user stopped typing
		this.timeout = setTimeout(() => {
			if (value.toUpperCase().startsWith("ORDO_MYLAB_")) {
				this.submitQRReaderPrescriptionModal(value);
			} else {
				if (!this.props.user.session?.themeHospital) {
					if (value.length === 41 && value.startsWith("\\") && value.charAt(7) === "S" && value.charAt(8) === "P") value = value.substring(7);
					if (value.length === 37 && value.startsWith("\\") && value.charAt(7) === "P" && value.charAt(8) === "R") value = value.substring(7);
					if (value.length === 34 && value.startsWith("SP")) {
						this.submitQRReaderSafePlaceModal(value);
						this.mounted && this.setState({ currentFilterSearch: "" });
					} else {
						if (value.length === 30) {
							if (value.startsWith("PR")) {
								this.submitQRReaderPreregisterModal(value);
								this.mounted && this.setState({ currentFilterSearch: "" });
							}
							if (value.startsWith("CA")) {
								this.submitQRReaderCampaignModal(value);
								this.mounted && this.setState({ currentFilterSearch: "" });
							}
						} else if (value.startsWith("DMORL01#AGI") || value.length === 36) {
							this.searchEPrescription(value);
						} else if (
							new RegExp("^(19|20)\\d{6,}").test(this.state.currentFilterSearch) ||
							new RegExp("^[A-zÀ-ž]{2,}").test(this.state.currentFilterSearch)
						) {
							this.mounted && this.setState({ searchStarted: true });
							this.searchPatients(1);
						} else if (new RegExp("^\\d{8,12}").test(this.state.currentFilterSearch)) {
							this.searchFolderWithTube();
						}
					}
				}
			}
		}, 500);
	};

	resetInput = () => {
		this.mounted && this.setState({ currentFilterSearch: "" });
	};

	resetFolderSearchInput = () => {
		this.mounted && this.setState({ currentFolderFilterSearch: "" });
		this.getFolders(null, null, null, null, "", null, false, true);
	};

	changeFolderSearchInput = (value) => {
		if (this.folderTimeout) clearTimeout(this.folderTimeout);

		if (value !== this.state.currentFolderFilterSearch) {
			this.mounted && this.setState({ currentFolderFilterSearch: value });
		}
		// Trigger the search after the user stopped typing
		this.folderTimeout = setTimeout(() => {
			if (this.state.currentFolderFilterSearch.length >= 2) {
				this.getFolders(null, null, null, 1, this.state.currentFolderFilterSearch, null, null);
			} else if (this.state.currentFolderFilterSearch.length === 0) {
				this.getFolders(null, null, null, 1, "", null, null);
			}
		}, 500);
	};

	changeSizePage = (e, { value }) => {
		this.getFolders(null, null, null, null, null, value, null);
	};
	getOptionsSize = () => {
		const { listTotalCount } = this.props.labAppointment;
		var pageSizes = [10, 20, 50, 100, 200];
		var result = [];
		var stop = false;
		pageSizes.forEach((s, index) => {
			if (!stop) {
				result.push({ key: index, value: s, text: s.toString() });
				if (listTotalCount < s) stop = true;
			}
		});
		this.mounted && this.setState({ optionsSize: result });
	};

	createImmediateAppointment = async (patient, tvSec, deposit) => {
		if (patient.mobile_phone && !checkPrefixePhoneNumer(patient.mobile_phone)) toast.warning("Le préfixe du GSM du patient est à vérifier.");
		if (!patient.externalIds || patient.externalIds.length === 0) {
			const newPatient = convertMyLabToPatient(patient);
			const postPatientResponse = await this.props.postPatient(newPatient);
			newPatient.id = postPatientResponse.payload.data.id;
			patient = newPatient;
		} else {
			await this.props.getPatientExistingFolder(patient.id);
		}

		const newAppointmentResponse = await this.newAppointment(patient.id);
		if (
			newAppointmentResponse &&
			newAppointmentResponse.payload &&
			newAppointmentResponse.payload.data &&
			newAppointmentResponse.payload.data.folders &&
			newAppointmentResponse.payload.data.folders.length > 0
		) {
			if (this.state.centerAppointmentId) {
				await this.props
					.associateCenterAppointmentWithFolder(this.state.centerAppointmentId, newAppointmentResponse.payload.data.folders[0].id)
					.then(() => {
						this.setState({ centerAppointmentId: null });
					});
			}
			if (!tvSec & !deposit) this.openFolderManager(newAppointmentResponse.payload.data.folders.map((i) => i.id));
			else {
				this.openAddNurseHelpModal(newAppointmentResponse.payload.data.folders[0], tvSec, deposit);
			}
		}
	};

	createFolderHelpAndQuit = async (folderId, analyzes, other, comment, dataPatient, barcodes, center, depositData) => {
		const { tvsec, deposit } = this.state;
		let res = await this.props.createFolderHelp(folderId, analyzes, other, comment, dataPatient, barcodes, center?.id, depositData, tvsec, deposit);
		if (!tvsec && deposit && res.payload.data.deposit?.folder?.id > 0) {
			this.openFolderManager([res.payload.data.deposit.folder.id]);
		} else {
			this.props.hideSidebar();
			this.closeAddNurseHelpModal();
			this.resetInput();
			let { startDate, endDate, showDone, page, search, size, centers, box } = this.props.foldersOverview.filters;
			this.getFolders(startDate, endDate, showDone, page, search, size, centers, box);
		}
	};

	newPatient = async (values) => {
		this.props.hideSidebar();
		if (values.doctor) {
			const myLabDoctor = this.props.doctors.list.find((doc) => doc.id === values.doctor.id);
			if (myLabDoctor) {
				// @see NURSE-341 `doctors.exists` is populated by this method at reducer stage
				// @see reducers/doctor.js
				await this.props.getDoctorExists(myLabDoctor.id);
				const localDoctor = { ...myLabDoctor.address, ...myLabDoctor };
				localDoctor.mylab_id = localDoctor.id;
				localDoctor.sil_id = myLabDoctor.external_id;
				//console.debug( "localDoctor POST/PATCH", localDoctor, this.props.doctors.exists );
				// The MYLAB doctor does not exist on NURSE
				if (this.props.doctors.exists === 0) {
					localDoctor.id = null; // Make sure it is null
					// @see NURSE-341 `doctors.doctor` is populated by this method at reducer stage
					// @see reducers/doctor.js
					await this.props.postDoctor(localDoctor);
					// With possible failure
					if (this.props.doctors.doctor) values.doctor.id = this.props.doctors.doctor.id;
				} else {
					localDoctor.id = this.props.doctors.exists;
					//await this.props.patchDoctor(localDoctor);
					console.warn(
						"[NURSE-341#460] PATCH doctor is disabled now (NURSEID#" + localDoctor.id + "; MYLABID#" + localDoctor.mylab_id + ")",
						localDoctor
					);
					values.doctor.id = localDoctor.id;
				}
			}
		}

		const myLabPatient = convertPatientToMyLab(values);
		this.props.postPatientMyLab(myLabPatient).then(async (res) => {
			if (res.payload && res.payload.data && res.payload.data.id && res.payload.data.id !== 0) {
				values.mylab_id = res.payload.data.id;
				values.mylab_is_active = res.payload.data.active;
				values.externalIds = [
					{
						external_id: res.payload.data.id,
						service: ServiceEnum.mylab,
					},
				];
				this.props.postPatient(values).then((result) => {
					if (result && result.payload && result.payload.data) {
						this.newAppointment(result.payload.data.id).then((r) => {
							if (r && r.payload && r.payload.data && r.payload.data.folders) {
								this.openFolderManager(r.payload.data.folders.map((i) => i.id));
							}
						});
					}
				});
			} else {
				toast.error("Impossible de créer le patient dans myLab.");
			}
		});
	};

	newAppointment = async (patientId, tempFolderId) => {
		const now = moment().format("YYYY-MM-DD[T]HH:mm");

		let data = {
			patient: patientId,
			_date: now.substr(0, 10),
			_time: now.substr(now.length - 5, 5),
			status: "NEW",
			center: this.props.user.session.center.id,
			box: this.props.user.session.box,
		};

		return await this.props.postLabAppointment(data, tempFolderId);
	};

	openFolderManager = (focusedFolders) => {
		this.props.setFocusedFolders(focusedFolders);
		this.mounted && this.setState({ openFolderManager: true });
		this.setBusyBoxOpeningFolder();
		// this.props.hideSidebar();
	};

	/** Folder Selection **/
	selectFolder = (id) => {
		const { folderSelection: set } = this.state;
		const folderSelection = set;
		if (folderSelection.has(id)) folderSelection.delete(id);
		else folderSelection.add(id);
		this.mounted && this.setState({ folderSelection });
	};

	selectPatient = (folder) => {
		this.props.setFocusedFolders([folder.id]);
		this.mounted && this.setState({ openFolderManager: true });
		this.setBusyBoxOpeningFolder();
	};

	getColorPriorityAnalyses = async (list) => {
		await asyncForEach(list, async (appointment) => {
			let highestAnalysis = {
				properties: {
					code: "Z",
					color_priority: 0,
					color: "#fff",
				},
			};

			await asyncForEach(appointment.folder.prescriptions, async (presc) => {
				await asyncForEach(presc.analyses, (ana) => {
					if (ana.properties.color !== null && ana.properties.color_priority >= highestAnalysis.properties.color_priority) {
						// Case same priority
						if (ana.properties.color_priority === highestAnalysis.properties.color_priority) {
							highestAnalysis =
								ana.properties.code.toLowerCase().localeCompare(highestAnalysis.properties.code.toLowerCase()) > 0 ? highestAnalysis : ana;
						} else {
							highestAnalysis = ana;
						}
					}
				});
			});
			appointment = { ...appointment, analysis_color: highestAnalysis.properties.color };
		});
		return list;
	};

	goToFolderManager = () => {
		this.props.setFocusedFolders(Array.from(this.state.folderSelection));
		this.mounted && this.setState({ openFolderManager: true });
	};

	/** Appointments manager **/
	patchAppointment = (data) => {
		this.props.patchLabAppointment(data, this.props.foldersOverview.filters.date);
	};
	doneAppointment = (id) => {
		let data = {
			status: "DONE",
			id: id,
		};

		this.props.patchLabAppointment(data, this.props.foldersOverview.filters.date);
	};

	deleteAppointment = (id) => {
		let data = {
			id: id,
		};

		this.props.deleteLabAppointment(data);
	};

	closeQRReaderPrescriptionModal = () => {
		this.mounted && this.setState({ QRReaderPrescriptionModal: false });
	};

	closePatientMatchingModal = () => {
		this.mounted &&
			this.setState({
				patientMatcher: null,
				safeplaceMyLab: null,
				safeplaceMyLabList: [],
				safeplaceLarger: false,
				safeplaceMpi: null,
				safeplaceDsp: null,
				safeplacePage: 1,
				preregister: null,
				safeplace: null,
				eprescriptionMyLab: null,
				ePrescriptionAgence: null,
				campaign: null,
			});
		this.props.sendPatientToDualScreen(null);
		this.props.getAssignedToMeFolderHelp(this.props.user.session.center && this.props.user.session.helpFoldersMyCenter);
	};
	selectPatientMyLab = (patient) => {
		this.mounted && this.setState({ safeplaceMyLab: patient });
		this.props.sendPatientToDualScreen(convertMyLabToPatient(patient));
	};
	deselectPatientMyLab = () => {
		this.mounted && this.setState({ safeplaceMyLab: null });
		this.props.sendPatientToDualScreen(null);
	};

	createPatient = async (patientMyLab) => {
		let localPatient = null;
		await this.props.postPatientMyLab(patientMyLab).then(async (res) => {
			if (res.payload && res.payload.data && res.payload.data.id && res.payload.data.id !== 0 && res.payload.status.toString().startsWith("20")) {
				localPatient = convertMyLabToPatient(res.payload.data);
				localPatient.externalIds = [
					{
						external_id: res.payload.data.id,
						service: ServiceEnum.mylab,
					},
				];
				await this.props.postPatient(localPatient).then(async (result) => {
					if (result && result.payload && result.payload.data) {
						localPatient.id = result.payload.data.id;
					} else {
						toast.error("Impossible de créer le patient dans Nurse");
					}
				});
			} else {
				toast.error("Impossible de créer le patient dans MyLab.");
			}
		});
		return localPatient;
	};

	submitPatientMatchingModal = async (patient, onlyNotDispensed, selectedDoctor) => {
		const { eprescriptionMyLab, campaign, preregister } = this.state;
		let resultPatient = await this.createOrUpdatePatient(convertPatientToMyLab(patient));
		let folder = campaign ? campaign.folder : preregister ? preregister.folder : null;
		if (!folder) {
			let folderId;
			if (eprescriptionMyLab) {
				folderId = await this.createFolderEPrescription(resultPatient, eprescriptionMyLab, onlyNotDispensed);
				this.setState({ eprescriptionMyLab: null });
			}

			if (folderId) this.openFolderManager([folderId]);
		} else {
			if (folder.patient && folder.patient.id !== resultPatient.id) this.props.changePatient(folder.id, resultPatient.id);

			if (folder.is_temp && folder.status !== "CANCELED") {
				const labAppointmentResult = await this.newAppointment(resultPatient.id, folder.id);
				if (!labAppointmentResult || !labAppointmentResult.payload) {
					toast.error("Une erreur s'est produite lors de la mise à jour du dossier");
					return null;
				}
			}
			if (folder.folderHelp && folder.folderHelp.status === "REASSIGNED") this.props.doneFolderHelp(folder.id);
			if (folder) this.openFolderManager([folder.id]);
		}
	};

	createFolderEPrescriptionAgence = async (selectedLocalPatient, selectedLocalDoctor, eprescriptionAgence, analysesToDispenseEPN) => {
		let patient = await this.createOrUpdatePatient(convertSafeplacePatientToMyLab(selectedLocalPatient));
		//CREATE FOLDER
		let localDoctor = null;
		let copyDoctors = [];
		//Doctor
		if (selectedLocalDoctor) {
			localDoctor = await this.createOrUpdateDoctor({ ...selectedLocalDoctor, mylab_id: selectedLocalDoctor.id });
		}
		//Appointment + folder
		const labAppointResult = await this.newAppointment(patient.id);
		const folderId = labAppointResult.payload.data.folders[0].id;

		const prescription = await this.createPrescriptionFromAgency(eprescriptionAgence, folderId, patient, localDoctor, copyDoctors);
		if (prescription) {
			const analysesData = {
				add: eprescriptionAgence.analyses
					.filter((a) => a.bionext.length === 1 && analysesToDispenseEPN.some((d) => d.code === a.code && d.toDispense))
					.map((a) => {
						return { id: a.bionext[0].id, aes_id: a.identifier };
					}),
				remove: [],
				withTubes: true,
				motivations: null,
			};
			await this.props.bulkAnalysesPrescription(analysesData, prescription, folderId);
		}
		//TVSEC
		if (eprescriptionAgence.analyses.some((a) => a.bionext.length !== 1 && analysesToDispenseEPN.some((d) => d.code === a.code && d.toDispense))) {
			let comment = "EPRESCRIPTION AGENCE";
			if (eprescriptionAgence.analyses.some((a) => a.bionext.length === 0 && analysesToDispenseEPN().some((d) => d.code === a.code && d.toDispense)))
				comment = comment.concat(
					"\n",
					`${
						eprescriptionAgence.analyses.filter(
							(a) => a.bionext.length === 0 && analysesToDispenseEPN().some((d) => d.code === a.code && d.toDispense)
						).length
					} analyses introuvables dans le catalogue`
				);
			if (eprescriptionAgence.analyses.some((a) => a.bionext.length > 1 && analysesToDispenseEPN().some((d) => d.code === a.code && d.toDispense)))
				comment = comment.concat(
					"\n",
					`${
						eprescriptionAgence.analyses.filter((a) => a.bionext.length > 1 && analysesToDispenseEPN().some((d) => d.code === a.code && d.toDispense))
							.length
					} analyses avec plusieurs correspondances internes `
				);
			await this.props.createFolderHelp(folderId, true, true, comment, patient, "", this.props.user.session.center.id);
			this.resetInput();
		} else if (folderId) this.openFolderManager([folderId]);
	};

	createFolderEPrescription = async (localPatient, eprescriptionMyLab, onlyNotDispensed) => {
		//CREATE FOLDER
		let localDoctor = null;
		let copyDoctors = [];
		//Doctor
		const myLabDoctor = eprescriptionMyLab.medical_staff_data;
		myLabDoctor.mylab_id = eprescriptionMyLab.issuer_id;
		myLabDoctor.code = myLabDoctor.provider_code;
		localDoctor = await this.createOrUpdateDoctor(myLabDoctor);
		if (eprescriptionMyLab.copy_to_medical_staff && eprescriptionMyLab.copy_to_medical_staff.length > 0) {
			for (let i = 0; i < eprescriptionMyLab.copy_to_medical_staff.length; i++) {
				let doctor = eprescriptionMyLab.copy_to_medical_staff[i];
				doctor.mylab_id = doctor.id;
				copyDoctors.push({ doctor: await this.createOrUpdateDoctor(doctor) });
			}
		}
		//Appointment + folder
		const labAppointResult = await this.newAppointment(localPatient.id);
		const folderId = labAppointResult.payload.data.folders[0].id;
		//Prescription
		const prescription = await this.createPrescription(eprescriptionMyLab, localPatient, localDoctor, folderId, eprescriptionMyLab.id, copyDoctors);
		if (prescription) {
			const catalogCodes =
				onlyNotDispensed && onlyNotDispensed.length > 0
					? onlyNotDispensed.join(",")
					: eprescriptionMyLab.items.map((a) => a.analysis_reference).join(",");
			await this.props.getMatchingAnalyses(catalogCodes, localPatient.identification);
			const { matchingIdList } = this.props.analysisLibrary;
			let motivations = [];
			const analysesWithMotivations = eprescriptionMyLab.items.filter((a) => a.options.length > 0);
			for (let i = 0; i < analysesWithMotivations.length; i++) {
				let analysis = analysesWithMotivations[i];
				// MARQTUM ADD MOTIVATION TO ALL MARQTUM ANALYSES
				if (analysis.options.some((o) => o.tag === "MARQTUM-M01")) {
					let marqTums = this.props.generalParameters.data.analysesMarqTum
						.split(",")
						.filter((anaMarqTum) =>
							(onlyNotDispensed && onlyNotDispensed.length > 0
								? onlyNotDispensed
								: eprescriptionMyLab.items.map((i) => i.analysis_reference)
							).includes(anaMarqTum)
						);
					for (let anaMarqTum in marqTums) {
						await this.props.getMatchingAnalyses(anaMarqTum, localPatient.identification).then((result) => {
							motivations.push({
								question_answer: analysis.options[0].other,
								value: analysis.options[0].code,
								analysisLibraryId: result.payload.data.anal[0],
							});
						});
					}
				} else
					await this.props.getMatchingAnalyses(analysis.analysis_reference.toString(), localPatient.identification).then((res) => {
						motivations.push({
							question_answer: analysis.options[0].other,
							value: analysis.options[0].code,
							analysisLibraryId: res.payload.data.anal[0],
						});
					});
			}
			//Analyses
			const analysesData = { add: matchingIdList, remove: [], withTubes: true, motivations: motivations };
			await this.props.bulkAnalysesPrescription(analysesData, prescription, folderId);
			if (
				onlyNotDispensed && onlyNotDispensed.length > 0
					? onlyNotDispensed.length !== matchingIdList.length
					: matchingIdList.length !== eprescriptionMyLab.items.length
			)
				toast.warn(`Attention! Nous n'avons pas pu ajouter toutes les analyses.`);
		}
		return folderId;
	};

	openIdentitoVigilanceModal = async (myLabPatient, centerAppointmentId = null) => {
		await this.props.getMatchingPatient(ServiceEnum.mylab, myLabPatient.id, convertForPatientMatcher(myLabPatient));
		const { exists } = this.props.patients;
		if (exists) {
			myLabPatient = { ...myLabPatient, externalIds: exists.externalIds, id: exists.id, mylab_id: myLabPatient.id };
			//last update is mylab (patch patient nurse)
			if (moment(myLabPatient.last_update).isBefore(moment(exists.updated_at))) {
				myLabPatient = convertPatientToMyLab(exists);
			} else {
				this.props.patchPatient({ ...convertMyLabToPatient(myLabPatient), id: exists.id }, true);
			}
		}
		this.mounted && this.setState({ identitoVigilanceModal: true, identitoVigilancePatient: myLabPatient, centerAppointmentId: centerAppointmentId });
		this.props.sendPatientToDualScreen(myLabPatient);
		this.setBusyBoxOpeningFolder();
	};

	closeIdentitoVigilanceModal = () => {
		this.mounted && this.setState({ identitoVigilanceModal: false, identitoVigilancePatient: {}, centerAppointmentId: null });
		this.props.sendPatientToDualScreen(null);
	};

	setBusyBoxOpeningFolder = async () => {
		const { live } = this.props;
		const { center, box } = this.props.user.session;

		let centerIndex, boxIndex;
		if (center) {
			centerIndex = live.findIndex((elt) => elt.id === parseInt(center));
			if (box && centerIndex > -1 && live[centerIndex]) {
				boxIndex = live[centerIndex].boxes.findIndex((elt) => elt.id === box.id);
				if (live[centerIndex].boxes[boxIndex].live === "#6ac906") this.props.setBusyBox(box);
			}
		}
	};

	submitIdentitoVigilanceModal = async (tvSec, deposit) => {
		this.mounted && this.setState({ identitoVigilanceModal: false });
		this.mounted && (await this.createImmediateAppointment(this.state.identitoVigilancePatient, tvSec, deposit));
	};

	submitWithUpdateIdentitoVigilanceModal = (l) => {
		this.mounted && this.setState({ identitoVigilanceModal: false });
		this.createImmediateAppointment(this.state.identitoVigilancePatient);
	};

	openQRReaderPrescriptionModal = () => {
		const scanAvailableState = {
			hasCameraAccess: true,
			QRReaderPrescriptionModal: true,
		};
		this.mounted && this.setState(scanAvailableState);
	};

	openQRReaderSafePlaceModal = () => {
		const scanAvailableState = {
			hasCameraAccess: true,
			QRReaderSafePlaceModal: true,
		};
		this.mounted && this.setState(scanAvailableState);
	};
	closeQRReaderSafePlaceModal = () => {
		this.mounted && this.setState({ QRReaderSafePlaceModal: false });
	};

	openAddNurseHelpModal = (folder, tvsec, deposit) => {
		this.mounted && this.setState({ addNurseHelpModalFolder: folder, openAddNurseHelpModal: true, tvsec, deposit });
	};
	closeAddNurseHelpModal = () => {
		this.mounted && this.setState({ openAddNurseHelpModal: false, addNurseHelpModalFolder: {}, tvsec: false, deposit: false });
	};

	openExpressDepositModal = () => {
		this.mounted && this.setState({ expressDepositModal: true });
		this.props.getAnalysesPacksForDeposits().then((res) => {});
	};
	openPlanning = () => {
		this.props.history.push("/home/planning");
	};
	closeExpressDepositModal = () => {
		this.mounted && this.setState({ expressDepositModal: false });
	};

	createOrUpdatePatient = async (myLabPatient) => {
		let mylabId = myLabPatient.mylab_id
			? myLabPatient.mylab_id
			: myLabPatient.externalIds && myLabPatient.externalIds.length > 0
			? myLabPatient.externalIds[0].external_id
			: 0;

		await this.props.getMatchingPatient(ServiceEnum.mylab, mylabId, convertForPatientMatcher(myLabPatient));

		const { exists } = this.props.patients;
		if (mylabId !== 0) {
			const myLabPatientRefresh = await this.props.getPatientMyLab(mylabId);
			const lastVersionMyLabPatient = convertMyLabToPatient(
				myLabPatientRefresh && myLabPatientRefresh.payload && myLabPatientRefresh.payload.data ? myLabPatientRefresh.payload.data : myLabPatient
			);
			myLabPatient = { ...myLabPatient, externalIds: exists?.externalIds, lastVersionMyLabPatient };
		} else {
			await this.props.postPatientMyLab(myLabPatient).then(async (res) => {
				if (res.payload && res.payload.data && res.payload.data.id && res.payload.data.id !== 0) {
					myLabPatient.mylab_id = res.payload.data.id;
					myLabPatient.externalIds = [
						{
							external_id: res.payload.data.id,
							service: ServiceEnum.mylab,
						},
					];
				}
			});
		}

		const localPatient = convertMyLabToPatient(myLabPatient);
		if (!exists) {
			const postPatientResult = await this.props.postPatient(localPatient);
			localPatient.id = postPatientResult.payload.data.id;
		} else {
			localPatient.id = exists.id;
			await this.props.patchPatient(localPatient);
		}
		return localPatient;
	};

	createOrUpdateDoctor = async (myLabDoctor) => {
		const localDoctor = { ...myLabDoctor.address, ...myLabDoctor };
		localDoctor.code = localDoctor.provider_code;
		// Not in returned data
		localDoctor.sil_id = myLabDoctor.external_id;

		// @see NURSE-341 `doctors.exists` is populated by this method at reducer stage
		// @see reducers/doctor.js
		await this.props.getDoctorExists(localDoctor.mylab_id);
		//console.debug( "localDoctor POST/PATCH", localDoctor, this.props.doctors.exists );
		// The MYLAB doctor does not exist on NURSE
		if (this.props.doctors.exists === 0) {
			localDoctor.id = null; // Make sure ID is null
			// @see NURSE-341 `doctors.doctor` is populated by this method at reducer stage
			// @see reducers/doctor.js
			await this.props.postDoctor(localDoctor);
			// With possible failure
			if (this.props.doctors.doctor) localDoctor.id = this.props.doctors.doctor.id;
		} else {
			localDoctor.id = this.props.doctors.exists;
			//await this.props.patchDoctor(localDoctor);
			console.warn(
				"[NURSE-341#950] PATCH doctor is disabled now (NURSEID#" + localDoctor.id + "; MYLABID#" + localDoctor.mylab_id + ")",
				localDoctor
			);
		}
		return localDoctor;
	};

	createPrescriptionFromAgency = async (eprescription, folderId, patient, doctor, copyDoctors = []) => {
		let prescription = {
			patient: patient.id,
			accident: false,
			reason: "",
			folder: folderId,
			prescriber: doctor ? doctor.id : null,
			issue_date: eprescription.valid_from,
			validity_date: eprescription.valid_to,
			agence_prescription_id: eprescription.identifier,
			copyDoctors: copyDoctors,
			prescriber_to_create_by_secretary: !doctor,
			show_mylab: true,
			to_be_faxed: false,
			to_be_phoned: false,
			urgent: false,
		};

		const prescriptionResult = await this.props.postPrescription(prescription);
		if (prescriptionResult.error) {
			toast.error("Impossible de créer la prescription, elle existe déjà");
			return null;
		}
		prescription.id = prescriptionResult.payload.data.id;
		return prescription;
	};

	createPrescription = async (scannedData, patient, doctor, folderId, mylabPrescriptionId = null, copyDoctors = [], agencePrescriptionId = null) => {
		const prescription = scannedData;
		prescription.id = null;
		prescription.accident = !!prescription.accident_number;
		prescription.reason = "";
		prescription.patient = patient.id;
		prescription.folder = folderId;
		prescription.prescriber = doctor.id;
		prescription.provider_barcode = prescription.reference;
		prescription.reference = null;
		prescription.issue_date = prescription.date;
		prescription.mylab_prescription_id = mylabPrescriptionId;
		prescription.agence_prescription_id = agencePrescriptionId;
		prescription.copyDoctors = copyDoctors;

		const prescriptionResult = await this.props.postPrescription(prescription);
		if (prescriptionResult.error) {
			toast.error("Impossible de créer la prescription, elle existe déjà");
			return null;
		}
		prescription.id = prescriptionResult.payload.data.id;
		return prescription;
	};

	createFolderSafePlace = async (localPatient, analysis, qrcode, transaction_id, voucher_code, myLabDoctor, company_id, files) => {
		//Appointment + folder
		const labAppointmentResult = await this.newAppointment(
			localPatient.id,
			this.props.safeplace.current.folder ? this.props.safeplace.current.folder.id : null
		);
		if (!labAppointmentResult || !labAppointmentResult.payload) {
			toast.error("Une erreur s'est produite lors de la création du dossier Safeplace");
			return null;
		}
		const folderId = labAppointmentResult.payload.data.folders[0].id;
		//use qr-code
		this.props.useSafePlaceQR(qrcode, this.props.user?.session?.center);

		//PRescriber
		let localDoctor = null;
		if (myLabDoctor) {
			// @see NURSE-341 `doctors.exists` is populated by this method at reducer stage
			// @see reducers/doctor.js
			await this.props.getDoctorExists(myLabDoctor.id);
			localDoctor = { ...myLabDoctor.address, ...myLabDoctor };
			localDoctor.mylab_id = localDoctor.id;
			localDoctor.sil_id = myLabDoctor.external_id;
			//console.debug( "localDoctor POST/PATCH", localDoctor, this.props.doctors.exists );
			// The MYLAB doctor does not exist on NURSE
			if (this.props.doctors.exists === 0) {
				localDoctor.id = null; // Make sure it is null
				// @see NURSE-341 `doctors.doctor` is populated by this method at reducer stage
				// @see reducers/doctor.js
				await this.props.postDoctor(localDoctor);
				// With possible failure
				if (this.props.doctors.doctor) localDoctor.id = this.props.doctors.doctor.id;
			} else {
				localDoctor.id = this.props.doctors.exists;
				//await this.props.patchDoctor(localDoctor);
				console.warn(
					"[NURSE-341#1041] PATCH doctor is disabled now (NURSEID#" + localDoctor.id + "; MYLABID#" + localDoctor.mylab_id + ")",
					localDoctor
				);
			}
		}

		//Prescription
		const prescription = {
			id: null,
			accident: false,
			reason: "",
			patient: localPatient.id,
			folder: folderId,
			prescriber: localDoctor,
			issue_date: null,
			validity_date: null,
			no_prescriber: !myLabDoctor,
			to_be_faxed: false,
			to_be_phoned: false,
			urgent: false,
			safeplace_code: this.state.safeplaceCode,
			billing_company: { sil_id: company_id },
		};

		const prescriptionResult = await this.props.postPrescription(prescription);
		if (prescriptionResult.payload.data.id && files) {
			files.map(async (file) => {
				const type = getFileType(file.name);
				if (type !== "") {
					let formData = new FormData();
					formData.append("scan", b64toFile(file.data, type, 512, file.name));
					formData.append("barcode", "");
					formData.append("document_type", 1);
					formData.append("fromSafeplace", true);
					await this.props.postScanPrescription(formData, prescriptionResult.payload.data.id, folderId);
				}
			});
		}
		if (prescriptionResult.error) {
			toast.error("Une erreur s'est produite lors de la création de la prescription");
			this.props.cancelSafePlaceQR(qrcode, this.props.user?.session?.center);
			return null;
		}
		if (transaction_id) await this.props.addPayment("stripe", folderId, transaction_id, analysis.price, true);
		if (voucher_code) await this.props.addPayment("voucher", folderId, voucher_code, analysis.price, true);
		prescription.id = prescriptionResult.payload.data.id;
		await this.props.getMatchingAnalyses(analysis.code, !!localPatient.identification);
		const { matchingIdList } = this.props.analysisLibrary;
		//Analyses
		const analysesData = {
			add: matchingIdList,
			remove: [],
			withTubes: true,
		};
		await this.props.bulkAnalysesPrescription(analysesData, prescription, folderId);
		//Remplir la question avec le numéro d'identité
		if (localPatient.identification) {
			this.props.editPIQuestionAnswer(folderId, localPatient.identification).catch((e) => {
				toast.warn(this.props.t("foldersOverview.errorPiQuestionAnswer"));
			});
		}
		this.openFolderManager([folderId]);
	};

	searchByMatricule = async (matricule, page, strict) => {
		this.setState({ safeplacePage: page, safeplaceMyLab: null });
		if (matricule) {
			if (strict) {
				await this.props.searchPatientsMyLab({ multiple_search: matricule }, 1000, 0);
				this.mounted &&
					this.setState({
						safeplaceLarger: this.props.patients.search.larger,
						safeplaceMyLabList: this.props.patients.search.list.filter((item) => item.cns === matricule),
						safeplacePagination: {
							total: this.props.patients.search.list.filter((item) => item.cns === matricule).length,
						},
					});
			} else {
				await this.props.searchPatientsMyLab({ multiple_search: matricule }, 20, (page - 1) * 20 + 1);
				if (
					(this.props.patients.search.pagination && this.props.patients.search.pagination.total === 0) ||
					this.props.patients.search.list.length === 0
				) {
					this.setState({
						safeplaceMyLabList: [],
						safeplaceLarger: false,
						safeplaceMyLab: null,
						safeplacePagination: this.props.patients.search.pagination,
					});
				} else {
					if (this.props.patients.search.list.length > 0)
						this.setState({
							safeplacePage: (this.props.patients.search.pagination.start - 1) / 20 + 1,
							safeplacePagination: this.props.patients.search.pagination,
							safeplaceLarger: this.props.patients.search.larger,
							safeplaceMyLabList: this.props.patients.search.list,
						});
				}
				//check mpi
				if (new RegExp("^[0-9]{13}$").test(matricule)) {
					this.props.getMpiPatientByMatricule(matricule).then(async (resMpi) => {
						if (resMpi.payload && resMpi.payload.data && resMpi.payload.data.length > 0) {
							this.mounted && this.setState({ safeplaceMpi: resMpi.payload.data[0] });
						}
					});
				} else {
					this.setState({ safeplaceMpi: null, safeplaceDsp: null });
				}
			}
		}
	};

	searchEPrescription = async (qrcode) => {
		let uid = qrcode.startsWith("DMORL01#AGI") ? qrcode.substring(11, 47) : qrcode;
		await this.props.getEPrescription(uid).then(async (res) => {
			this.setState({ ePrescriptionAgence: res.payload.data, patientMatcher: { patient: res.payload.data.patient, folder: null } });
		});
		//VERIFICATION INFO PATIENT
		// let patient = res.payload.data.patient;
		//CONVERT TO PATIENT
		//MATCH PATIENT
		//CHECK PRESCRIPTOR
		// let doctor = res.payload.data.prescriber;
		//CONVERT TO DOCTOR
		//CREATION DOSSIER
	};

	submitQRReaderPreregisterModal = async (qrcode) => {
		await this.props.getPreregisterAppointment(qrcode, this.props.user.session.center.id);
		if (this.props.preregister.current) {
			let preregisterResult = this.props.preregister.current;
			let preregisterPatient = convertPreregisterResultToPatient(preregisterResult);
			this.setState({
				preregisterCode: qrcode,
				preregister: preregisterResult,
				patientMatcher: { patient: preregisterPatient, folder: this.props.preregister.current.folder },
			});

			// NURSE 243 - If the urgency of a help_file is still false when scanning the pre-registration of the nurse in the center,
			// we deliberately set it to true in order to speed up the process
			if (!preregisterResult.folder.folderHelp.urgent) {
				await this.props.postPreregisterForceStatusUrgent(preregisterResult.folder.folderHelp);
			}
		}
	};

	submitQRReaderCampaignModal = async (qrcode) => {
		await this.props.getCampaignResultByQrCode(qrcode);
		let campaignResult = this.props.campaigns.current;
		if (campaignResult && campaignResult.message) {
			toast.warning(campaignResult.message);
			return;
		}
		this.setState({
			campaignCode: qrcode,
			campaign: campaignResult,
			isCampaign: true,
			patientMatcher: { patient: campaignResult.folder.patient, folder: campaignResult.folder },
		});
	};

	cancelFolderHelp = async (folderHelpId, comment, qrcode) => {
		await this.props.cancelFolderHelp(folderHelpId, comment);
		this.submitQRReaderPreregisterModal(qrcode);
	};

	submitQRReaderSafePlaceModal = async (qrcode) => {
		await this.props
			.getSafePlaceAppointment(qrcode)
			.then(async () => {
				let safeplaceResult = this.props.safeplace.current.data;
				if (safeplaceResult && safeplaceResult.analysis) {
					this.mounted && this.setState({ safeplaceCode: qrcode, safeplaceResult });

					//1. VERIFICATION INFO PATIENT
					let safeplacePatient = convertSafePlaceResultToPatient(safeplaceResult);
					if (safeplacePatient.mylab_id === 0) {
						this.setState({ safeplace: safeplaceResult, patientMatcher: { patient: safeplacePatient, folder: this.props.safeplace.current.folder } });
					} else {
						let localPatient;
						await this.props.getMatchingPatient(ServiceEnum.mylab, safeplacePatient.mylab_id, convertForPatientMatcher(safeplacePatient));
						const { exists } = this.props.patients;
						if (!exists) {
							const patientMyLab = await this.props.getPatientMyLab(safeplaceResult.mylab_id);
							localPatient =
								patientMyLab && patientMyLab.payload && patientMyLab.payload.data
									? convertMyLabToPatient(patientMyLab.payload.data)
									: safeplacePatient;
							const postPatientResult = await this.props.postPatient(localPatient);
							if (postPatientResult && postPatientResult.payload && postPatientResult.payload.data) {
								localPatient.id = postPatientResult.payload.data.id;
							} else {
								toast.warning("Une erreur est survenue lors de la création du patient dans MyLabNurse, veuillez rééssayer.");
							}
						} else {
							localPatient = {
								...exists,
								mobile_phone: safeplacePatient.mobile_phone,
								email: safeplacePatient.email,
								identification: safeplacePatient.identity_number,
							};
							await this.props.patchPatient(localPatient);
						}
						if (localPatient)
							await this.createFolderSafePlace(
								localPatient,
								safeplaceResult.analysis,
								this.state.safeplaceCode,
								safeplaceResult.transaction_id,
								safeplaceResult.voucher,
								safeplaceResult.prescriber,
								safeplaceResult.company_id,
								safeplaceResult.files
							);
					}
				}
			})
			.catch(() => {
				toast.warning("Une erreur est survenue lors de la récupération des informations Safeplace.");
			});
	};

	submitQRReaderPrescriptionModal = async (values) => {
		this.mounted && this.setState({ prescriptionIsLoading: true });
		const mylabPrescriptionId = values.split(/_/).pop();
		if (!mylabPrescriptionId) {
			toast.warn("Prescription non trouvée");
			this.mounted && this.setState({ prescriptionIsLoading: false });
		} else {
			const scanResult = await this.props.getPrescriptionByBarcode(Number(mylabPrescriptionId));

			if (scanResult && scanResult.payload && scanResult.payload.data && scanResult.payload.data.result && scanResult.payload.data.result.id) {
				let eprescriptionMyLab = {
					...scanResult.payload.data.result,
					patient: scanResult.payload.data.patient,
					otherDispenses: scanResult.payload.data.othersPrescriptions,
				};
				this.setState({
					eprescriptionMyLab,
					patientMatcher: { patient: eprescriptionMyLab.patient_data, folder: null, patientMyLabNurse: eprescriptionMyLab.patient },
				});
			} else {
				toast.warn("Prescription non trouvée");
			}
			this.mounted && this.setState({ prescriptionIsLoading: false });
		}
	};

	closeQRReaderCnsModal = () => {
		this.mounted && this.setState({ QRReaderCnsModal: false });
	};

	openQRReaderCnsModal = () => {
		this.mounted && this.setState({ hasCameraAccess: true, QRReaderCnsModal: true });
	};

	openPaymentModal = async (myLabPatient) => {
		await this.props.getInvoicesForPatient(myLabPatient.id);
		await this.props.getCasingForPatient(myLabPatient.id, this.props.user.session.center.id);
		this.mounted && this.setState({ paymentModal: true, paymentPatient: myLabPatient });
	};

	closePaymentModal = () => {
		if (this.props.casing && this.props.casing.payments && this.props.casing.payments.length > 0) {
			this.mounted && this.setState({ confirmCloseCasingPaymentModal: true });
		} else {
			this.props.resetInvoicesForPatient();
			this.mounted && this.setState({ paymentModal: false, paymentPatient: null });
		}
	};
	openCheckinModal = async (myLabPatient) => {
		await this.props.getCheckinsForPatient(myLabPatient.id);
		this.mounted && this.setState({ checkinModal: true, checkinPatient: myLabPatient });
	};
	closeCheckinModal = async () => {
		this.mounted && this.setState({ checkinModal: false, checkinPatient: null });
	};

	exportCasingPaymentsToGeslab = async () => {
		await this.props.exportCasingForPatient(this.props.casing.id).then(() => this.setState({ paymentModal: false, paymentPatient: null }));
	};

	cancelConfirmCloseCasingPaymentModal = () => {
		this.mounted && this.setState({ confirmCloseCasingPaymentModal: false });
	};
	closeConfirmCloseCasingPaymentModal = () => {
		this.props
			.cancelCasingForPatient(this.state.paymentPatient?.id)
			.then(() => this.mounted && this.setState({ confirmCloseCasingPaymentModal: false, paymentModal: false, paymentPatient: null }));
		this.props.resetInvoicesForPatient();
	};
	addPaymentCasing = async (payment) => {
		await this.props.addPayment(
			payment.type,
			null,
			null,
			payment.amount,
			true,
			null,
			payment.partition,
			null,
			payment.externalId,
			payment.patient_name
		);
		await this.props.getCasingForPatient(payment.externalId, this.props.user.session.center.id);
	};

	openReopenFolderModal = async (myLabPatient) => {
		await this.props.getMatchingPatient(ServiceEnum.mylab, myLabPatient.id, convertForPatientMatcher(myLabPatient));

		const { exists } = this.props.patients;
		await this.props.getPatientClosedFolders(exists?.id || 0);
		this.mounted &&
			this.setState({
				reopenFolderModalOpen: true,
			});
	};

	closeReopenFolderModal = () =>
		this.mounted &&
		this.setState({
			reopenFolderModalOpen: false,
		});

	submitReopenFolderModal = async (folderId, reopen) => {
		if (reopen) await this.props.openFolder(folderId);
		this.openFolderManager([folderId]);
	};

	notifyMeForPreregister = async (folderHelpId) => {
		this.props.notifyMeForPreregister(folderHelpId);
	};

	getPatientAndCreateFolder = async (myLabPatientId, centerAppointmentId) => {
		const patientMyLab = await this.props.getPatientMyLab(myLabPatientId);
		this.openIdentitoVigilanceModal(patientMyLab?.payload?.data, centerAppointmentId);
	};

	render() {
		const { list, loading, pages, listTotalCount } = this.props.labAppointment;
		const { filters, patientClosedFolders, size } = this.props.foldersOverview;
		const { patients, generalParameters, user, t } = this.props;
		const { search } = patients;
		const { openFolderManager, currentFilterSearch, currentFolderFilterSearch, searchStarted, reopenFolderModalOpen, optionsSize } = this.state;
		const { center } = this.props.user.session;
		const isNurse = user.session.role === "NURSE";

		if (openFolderManager) {
			return <Redirect to="/home/foldermanager" />;
		}
		if (list === null || list === undefined) {
			return <div>&nbsp;</div>;
		} else {
			return (
				<div style={styles.containerStyle}>
					<Dimmer active={patients.loading || this.state.prescriptionIsLoading}>
						<Loader />
					</Dimmer>
					<RepetitiveCalls
						getMyOpenedFolders={this.props.getMyOpenedFolders}
						getFoldersWaitingTubes={this.props.getFoldersWaitingTubes}
						getFoldersWaitingAliquots={isNurse && center && center.aliquotLevel !== "NOALIQUOT" ? this.props.getFoldersWaitingAliquots : null}
						center={center}
						getAssignedToMeFolderHelp={this.props.generalParameters.data.helpNurse ? this.props.getAssignedToMeFolderHelp : null}
						inCenter={center && this.props.user.session.helpFoldersMyCenter}
						list={list}
					/>

					<Grid style={{ margin: 0 }}>
						<Grid.Row style={{ alignItems: "center" }}>
							{isNurse && (
								<Grid.Column mobile={8} tablet={2} computer={2} style={{ margin: isMobile() ? "10px 0" : 0, padding: 0 }}>
									<MainButton
										text={<Icon name="home" style={{ margin: 0 }} />}
										style={{ height: 40 }}
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											this.props.resetLabAppointmentList();
											this.props.setTab(0);
											this.props.resetMode();
										}}
									/>
								</Grid.Column>
							)}

							{/* {isMobile() && (
								<Grid.Column mobile={8} style={{ textAlign: "right", padding: 0 }}>
									<Button
										color="teal"
										icon="qrcode"
										content="safeplace"
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											this.openQRReaderSafePlaceModal();
										}}
										style={{ margin: "0.2em 0" }}
									/>
									<Button
										color="teal"
										icon="qrcode"
										content="e-prescription"
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											this.openQRReaderPrescriptionModal();
										}}
										style={{ margin: "0.2em 0" }}
									/>

									<Button
										color="teal"
										icon="add"
										content="Patient"
										onClick={(e) => {
											if (e !== undefined) e.preventDefault();
											this.props.openSidebar(
												<AddPatient filter={currentFilterSearch} hideSidebar={this.props.hideSidebar} onSubmit={this.newPatient} />
											);
										}}
										style={{ margin: "0.2em 0" }}
									/>
								</Grid.Column>
							)} */}

							<Grid.Column mobile={16} tablet={16} computer={isNurse ? 10 : 12} style={{ margin: isMobile() ? "10px 0" : 0, padding: 0 }}>
								<Grid.Row style={{ display: "flex" }}>
									<Grid.Column style={{ flex: 1 }}>
										<URLOrdoMyLab changeFilterInput={this.changeFilterInput} openNewFolder={this.getPatientAndCreateFolder} />
										<SearchInput
											onChange={(e) => this.changeFilterInput(e.target.value)}
											current={currentFilterSearch}
											resetInput={this.resetInput}
											placeholder={
												!!this.props.user.session?.themeHospital
													? t("foldersOverview.searchPlaceHolderHospital")
													: t("foldersOverview.searchPlaceHolder")
											}
											autoFocus
										/>
									</Grid.Column>
								</Grid.Row>
							</Grid.Column>

							<Grid.Column
								mobile={8}
								tablet={2}
								computer={4}
								style={{ margin: isMobile() ? "10px 0" : 0, display: "flex", justifyContent: "flex-end" }}
							>
								{this.props.center?.expressAvailable && (
									<Popup
										content="Dépôt express"
										position={"top center"}
										trigger={
											<MainButton
												text={
													<>
														<Image
															src={window.location.origin + "/icones/depot.svg"}
															style={{ filter: "invert(100%) sepia(0%) saturate(2%) hue-rotate(96deg) brightness(108%) contrast(101%)" }}
															height="25"
														/>{" "}
													</>
												}
												style={{ height: 40, padding: "0 10px" }}
												onClick={(e) => {
													if (e !== undefined) e.preventDefault();
													this.openExpressDepositModal();
												}}
											/>
										}
									/>
								)}
								{this.props.center?.myrdvId && (
									<Popup
										content="Planning de rendez-vous"
										position={"top center"}
										trigger={
											<MainButton
												text={<Icon name="calendar alternate outline" style={{ margin: 0 }} />}
												style={{ height: 40 }}
												onClick={(e) => {
													if (e !== undefined) e.preventDefault();
													this.openPlanning();
												}}
											/>
										}
									/>
								)}
							</Grid.Column>
						</Grid.Row>
					</Grid>
					{search.larger && !search.loading && searchStarted && (
						<Grid style={{ margin: 0 }}>
							<Grid.Row style={{ ...styles.roundHeaderContainer, height: 40, backgroundColor: "red" }}>
								<Grid.Column style={{ ...styles.columnFlex, justifyContent: "space-between" }} mobile={16} tablet={16} computer={16}>
									<div style={{ ...styles.columnFlex, color: "#fff", fontWeight: 600 }}>
										<Icon name="user x" size="large" style={{ ...styles.icon, marginRight: "10px" }} />{" "}
										<span>
											{t("foldersOverview.patientNotFound")} <span style={{ textTransform: "uppercase" }}>{t("foldersOverview.withThisNumber")}</span>{" "}
										</span>
									</div>
								</Grid.Column>
							</Grid.Row>
							<div
								style={{
									width: "100%",
									textAlign: "center",
									marginTop: "1em",
								}}
							></div>
						</Grid>
					)}
					{currentFilterSearch.length >= 2 && searchStarted && (
						<Grid style={{ margin: 0 }}>
							<Grid.Row style={{ ...styles.roundHeaderContainer, height: 40, backgroundColor: search.larger ? "darkorange" : "#43b39e" }}>
								<Grid.Column
									style={{
										...styles.columnFlex,
										justifyContent: "space-between",
										width: "100%",
									}}
									mobile={16}
									tablet={16}
									computer={16}
								>
									<div
										style={{
											...styles.columnFlex,
											justifyContent: "flex-start",
											color: "#fff",
											fontWeight: 600,
										}}
									>
										{this.props.patients.search.pagination &&
											Math.ceil(this.props.patients.search.pagination.total / this.state.patientNbItems) > 1 && (
												<Icon name="warning sign" color="red" style={styles.icon} />
											)}
										{this.props.patients.search.pagination &&
											Math.ceil(this.props.patients.search.pagination.total / this.state.patientNbItems) < 2 && (
												<Icon name={search.pagination.total === 0 ? "user x" : "users"} style={{ ...styles.icon, marginRight: "15px" }} />
											)}
										{!search.loading && search.list && search.pagination && (
											<span>
												{search.pagination.total === 0 ? "Aucun" : search.pagination.total} {t("foldersOverview.patient")}
												{search.pagination.total > 1 ? "s" : ""} {t("foldersOverview.find")}
												{search.pagination.total > 1 ? "s" : ""}
												{search.larger ? (
													<span style={{ textTransform: "uppercase" }}>{t("foldersOverview.sameBirthIncompletRegisterNumber")}</span>
												) : (
													"."
												)}
											</span>
										)}
									</div>

									{this.props.patients.search.pagination &&
										Math.ceil(this.props.patients.search.pagination.total / this.state.patientNbItems) > 1 && (
											<div
												style={{
													...styles.columnFlex,
													color: "#fff",
													fontWeight: 600,
													fontSize: "1.1em",
												}}
											>
												{t("foldersOverview.refineSearch")}
											</div>
										)}

									{this.props.patients.search.pagination &&
										Math.ceil(this.props.patients.search.pagination.total / this.state.patientNbItems) > 1 && (
											<div
												style={{
													...styles.columnFlex,
													color: "#fff",
													fontWeight: 600,
												}}
											>
												<span>
													{t("foldersOverview.page")} {this.state.patientPaging}/
													{Math.ceil(this.props.patients.search.pagination.total / this.state.patientNbItems)}{" "}
												</span>
											</div>
										)}
								</Grid.Column>
							</Grid.Row>

							{search.loading && (
								<div style={{ width: "100%", textAlign: "center", marginTop: "1em", marginBottom: "1em" }}>
									<Loader active inline />
								</div>
							)}

							{!search.loading &&
								search.list?.map((l, index) => {
									return (
										<Grid.Row key={"appoint" + index} style={_appointmentContainer(index % 2 === 0)}>
											<Grid.Column mobile={16} tablet={5} computer={5}>
												<div>
													<b>
														{displayGender(l, generalParameters.data)} {displayName(l)}
													</b>
													<br />
													{l.birth_date && (
														<span style={{ fontSize: "0.8em", fontStyle: "italic" }}>
															{moment().diff(l.birth_date, "years")} {t("foldersOverview.years")}
														</span>
													)}
												</div>
											</Grid.Column>

											<Grid.Column mobile={16} tablet={3} computer={3} style={{}}>
												{l.birth_date && (
													<b style={{ fontSize: "0.8em" }}>
														{" "}
														{t(l.gender === "f" ? "foldersOverview.bornF" : "foldersOverview.bornM")}
														{t("foldersOverview.the")}
														{moment(l.birth_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}
													</b>
												)}
											</Grid.Column>

											<Grid.Column mobile={16} tablet={3} computer={3} style={{}}>
												<div>
													<b style={{ fontSize: "0.8em" }}>
														{t("foldersOverview.number")}
														{l.cns}
													</b>
												</div>
												{l.active && (
													<span style={{ fontSize: "0.8em" }}>
														<Icon name="heart" /> {t("foldersOverview.actifMylab")}
													</span>
												)}
											</Grid.Column>

											<Grid.Column mobile={16} tablet={5} computer={5} style={{ textAlign: "right", display: "flex", justifyContent: "flex-end" }}>
												<MainButton
													text={t("foldersOverview.newFolder")}
													onClick={(e) => {
														if (e !== undefined) {
															e.preventDefault();
															e.stopPropagation();
														}
														this.openIdentitoVigilanceModal(l);
													}}
												/>

												<Dropdown icon="ellipsis horizontal" button className="icon">
													<Dropdown.Menu floating direction="left">
														<Dropdown.Item
															onClick={(e) => {
																if (e !== undefined) {
																	e.preventDefault();
																	e.stopPropagation();
																}
																this.openReopenFolderModal(l);
															}}
														>
															<Icon name="folder outline" />
															{t("foldersOverview.oldFolder")}
														</Dropdown.Item>
														<Dropdown.Item
															onClick={(e) => {
																if (e !== undefined) {
																	e.preventDefault();
																	e.stopPropagation();
																}
																this.openPaymentModal(l);
															}}
														>
															<Icon name="credit card outline" />
															Encaisser
														</Dropdown.Item>
														<Dropdown.Item
															onClick={(e) => {
																if (e !== undefined) {
																	e.preventDefault();
																	e.stopPropagation();
																}
																this.openCheckinModal(l);
															}}
														>
															<Icon name="qrcode" />
															Nouveau CHECKIN
														</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown>
											</Grid.Column>
										</Grid.Row>
									);
								})}
							{!search.loading &&
								search.list &&
								search.pagination &&
								(search.larger || search.pagination.total === 0 || search.pagination.total < search.pagination.start + search.pagination.limit) && (
									<div
										style={{
											width: "100%",
											textAlign: "center",
											marginTop: "1em",
											marginBottom: "1em",
										}}
									>
										<SecondaryBlueButton
											text={t("foldersOverview.newFolderWithPatient")}
											onClick={(e) => {
												if (e !== undefined) e.preventDefault();
												this.props.openSidebar(
													<AddPatient filter={currentFilterSearch} hideSidebar={this.props.hideSidebar} onSubmit={this.newPatient} />
												);
											}}
										/>
									</div>
								)}
							{!search.loading && search.pagination && Math.ceil(search.pagination.total / this.state.patientNbItems) > 1 && (
								<Grid.Row>
									<CustomPagination
										activePage={this.state.patientPaging}
										totalPages={Math.ceil(this.props.patients.search.pagination.total / this.state.patientNbItems)}
										onPageChange={(e, { activePage }) => {
											this.searchPatients(activePage);
										}}
									/>
								</Grid.Row>
							)}
						</Grid>
					)}

					<Grid style={{ margin: 0 }}>
						{
							<>
								<Grid.Row style={{ display: "inline" }}>
									{center && (
										<Grid>
											<Grid.Row style={styles.roundHeaderContainer}>
												<Grid.Column
													style={{ color: "#fff", fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "flex-start" }}
													mobile={6}
													tablet={3}
													computer={2}
												>
													<Icon name="folder" style={styles.icon} />
													{listTotalCount + " " + t("foldersOverview.folders")}
												</Grid.Column>
												{/* <Grid.Column mobile={4} tablet={0} computer={0}>
														</Grid.Column> */}
												<Grid.Column
													style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", height: "34px", padding: 0 }}
													mobile={10}
													tablet={5}
													computer={3}
												>
													<SearchInput
														onChange={(e) => this.changeFolderSearchInput(e.target.value)}
														current={currentFolderFilterSearch}
														resetInput={this.resetFolderSearchInput}
														placeholder={t("foldersOverview.folderSearchPlaceHolder")}
														style={styles.searchFolders}
														className="react-input-white"
														styleicon={styles.searchFoldersIcon}
													/>
												</Grid.Column>
												<Grid.Column
													mobile={10}
													tablet={8}
													computer={8}
													style={{
														display: "flex",
														alignItems: "center",
														justifyContent: "flex-start",
													}}
												>
													<Icon name="calendar alternate" style={styles.icon} />
													<span style={styles.dateText}>{t("foldersOverview.from")}</span>
													<div style={{ width: 75 }}>
														<DatePicker
															selected={new Date(filters.startDate)}
															onChange={(date) => this.getFolders(date, null, null, 1, null, null, null, null)}
															className="datePicker"
															shouldCloseOnSelect={false}
															onFocus={(e) => (e.target.readOnly = isMobile())}
															dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
														/>
													</div>
													<span style={styles.dateText}>{t("foldersOverview.to")}</span>
													<div style={{ width: 75, marginRight: "15px" }}>
														<DatePicker
															selected={new Date(filters.endDate)}
															onChange={(date) => this.getFolders(null, date, null, 1, null, null, null, null)}
															className="datePicker"
															shouldCloseOnSelect={false}
															onFocus={(e) => (e.target.readOnly = isMobile())}
															dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
														/>
													</div>
													<div
														style={{
															display: "flex",
															alignItems: "center",
															justifyContent: "flex-end",
														}}
													>
														{this.props.user.session.box && !isMobile() && (
															<>
																<Checkbox
																	//slider
																	checked={filters.box}
																	onChange={(e) => this.getFolders(null, null, null, 1, null, null, filters.centers ? false : null, !filters.box)}
																/>
																<div style={{ fontSize: "0.8em", color: "#fff", margin: "0 20px 0 5px" }}>{t("foldersOverview.myBox")}</div>
															</>
														)}
														{this.props.user.session.access_centers === null && !isMobile() && (
															<>
																<Checkbox
																	//slider
																	checked={!filters.centers}
																	onChange={(e) =>
																		this.getFolders(null, null, null, 1, null, null, !filters.centers, !filters.centers ? false : null)
																	}
																/>
																<div style={{ fontSize: "0.8em", color: "#fff", margin: "0 20px 0 5px" }}>{t("foldersOverview.myCenter")}</div>
															</>
														)}
														<Checkbox
															//slider
															checked={filters.showDone}
															onChange={(e) => this.getFolders(null, null, !filters.showDone, 1, null, null, null, null)}
														/>
														<div style={{ fontSize: "0.8em", color: "#fff", margin: `0 10px 0 5px` }}>{t("foldersOverview.completedFolder")}</div>
													</div>
												</Grid.Column>

												<Grid.Column
													mobile={10}
													tablet={4}
													computer={3}
													style={{
														display: "flex",
														alignItems: "center",
														justifyContent: "flex-end",
														padding: 0,
													}}
												>
													<div style={styles.nombreItem}>
														<div style={styles.nombreItemLabel}>{t("foldersOverview.folderPerPage")}</div>
														<Menu compact style={styles.nombreItemMenu}>
															<Dropdown text={String(size)} options={optionsSize} onChange={this.changeSizePage} />
														</Menu>
													</div>
													<Button
														icon
														color="teal"
														size="tiny"
														onClick={() => this.getFolders(null, null, filters.showDone, 1, null, null, null, null)}
													>
														<Icon name="refresh" />
													</Button>
													{!isMobile() && (
														<Popup
															content={this.state.hideList ? "Afficher la liste des dossiers" : "Cacher la liste des dossiers"}
															position="top right"
															trigger={
																<Button icon color="orange" size="tiny" onClick={() => this.toggleHideList()}>
																	<Icon name={this.state.hideList ? "unhide" : "hide"} />
																</Button>
															}
														/>
													)}
												</Grid.Column>
												{isMobile() && this.props.user.session.access_centers === null && isMobile() && (
													<Grid.Column
														mobile={6}
														tablet={4}
														computer={3}
														style={{
															display: "flex",
															alignItems: "center",
															justifyContent: "flex-end",
															padding: 0,
														}}
													>
														<>
															<Checkbox
																//slider
																checked={!filters.centers}
																onChange={(e) => this.getFolders(null, null, null, 1, null, null, !filters.centers, null)}
															/>
															<div style={{ fontSize: "0.8em", color: "#fff", margin: "0 20px 0 5px" }}>{t("foldersOverview.myCenter")}</div>
														</>
													</Grid.Column>
												)}
											</Grid.Row>

											{loading && (
												<div style={{ width: "100%", textAlign: "center", margin: 10 }}>
													<Loader inline active />
												</div>
											)}

											{!loading &&
												((!filters.showDone && list?.filter((folder) => folder.status !== "DONE" && folder.status !== "CANCELED").length === 0) ||
													(filters.showDone && list?.length === 0)) && (
													<div style={{ width: "100%", textAlign: "center", margin: 10 }}>{t("foldersOverview.noFolderInProgress")}</div>
												)}

											{!loading && (
												<FoldersList
													filters={filters}
													hideList={this.state.hideList}
													list={list}
													generalParameters={this.props.generalParameters}
													refreshFolders={this.refreshFolders}
													selectPatient={this.selectPatient}
													openFolder={this.props.openFolder}
													doneFolderHelp={this.props.doneFolderHelp}
													user={this.props.user}
													getAllPrescriptionScans={this.props.getAllPrescriptionScans}
													t={t}
												/>
											)}
										</Grid>
									)}
								</Grid.Row>
							</>
						}
					</Grid>
					{pages > 1 && (
						<CustomPagination
							activePage={filters.page}
							totalPages={pages}
							onPageChange={(e, { activePage }) => this.getFolders(null, null, null, activePage, null, null, null, null)}
						/>
					)}
					<QRReaderPrescriptionModal
						open={this.state.QRReaderSafePlaceModal}
						close={this.closeQRReaderSafePlaceModal}
						submit={this.submitQRReaderSafePlaceModal}
						hasCameraAccess={this.state.hasCameraAccess}
					/>
					<PatientMatchingModal
						open={!!this.state.patientMatcher}
						close={this.closePatientMatchingModal}
						submit={this.submitPatientMatchingModal}
						data={this.state.patientMatcher}
						searchByMatricule={this.searchByMatricule}
						mpi={this.state.safeplaceMpi}
						dsp={this.state.safeplaceDsp}
						mylab={this.state.safeplaceMyLab}
						mylabList={this.state.safeplaceMyLabList}
						page={this.state.safeplacePage}
						mylabPagination={this.state.safeplacePagination}
						mylabListLarger={this.state.safeplaceLarger}
						selectPatientMyLab={this.selectPatientMyLab}
						deselectPatientMyLab={this.deselectPatientMyLab}
						generalParameters={generalParameters}
						notifyMeForPreregister={this.notifyMeForPreregister}
						refreshPreregisterFolder={this.submitQRReaderPreregisterModal}
						cancelFolderHelp={this.cancelFolderHelp}
						isNurse={isNurse}
						campaign={this.state.campaign}
						preregister={this.state.preregister}
						safeplace={this.state.safeplace}
						eprescription={this.state.eprescriptionMyLab}
						eprescriptionAgence={this.state.ePrescriptionAgence}
						searchDoctors={this.props.searchDoctors}
						submitEprescriptionAgence={this.createFolderEPrescriptionAgence}
						isThemeHospital={!!this.props.user.session?.themeHospital}
					/>
					<QRReaderPrescriptionModal
						open={this.state.QRReaderPrescriptionModal}
						close={this.closeQRReaderPrescriptionModal}
						submit={this.submitQRReaderPrescriptionModal}
						hasCameraAccess={this.state.hasCameraAccess}
					/>
					<QRReaderPrescriptionModal
						open={this.state.QRReaderCnsModal}
						close={this.closeQRReaderCnsModal}
						submit={this.changeFilterInput}
						hasCameraAccess={this.state.hasCameraAccess}
					/>
					<ReopenFolderModal
						open={reopenFolderModalOpen}
						close={this.closeReopenFolderModal}
						submit={this.submitReopenFolderModal}
						folders={patientClosedFolders}
						user={this.props.user}
					/>
					<Confirm
						open={this.state.confirmCloseCasingPaymentModal}
						onCancel={this.cancelConfirmCloseCasingPaymentModal}
						onConfirm={this.closeConfirmCloseCasingPaymentModal}
						content="Êtes-vous sûr de vouloir fermer et annuler les paiements ?"
						cancelButton="Non"
						confirmButton="Oui"
					/>
					<CasingPaymentModal
						open={this.state.paymentModal}
						close={this.closePaymentModal}
						exportGeslab={this.exportCasingPaymentsToGeslab}
						patient={this.state.paymentPatient}
						invoices={this.props.invoices}
						center={this.props.center}
						casing={this.props.casing}
						t={t}
						addPayment={this.addPaymentCasing}
						casingPaymentCancel={this.props.casingPaymentCancel}
					/>
					<IdentitoVigilanceModal
						open={this.state.identitoVigilanceModal}
						close={this.closeIdentitoVigilanceModal}
						submit={this.submitIdentitoVigilanceModal}
						submitWithUpdate={this.submitWithUpdateIdentitoVigilanceModal}
						patient={this.state.identitoVigilancePatient}
						tvSecActivated={this.props.user.session.role === "NURSE" && this.props.user.session.center?.isTvSecActivated}
						secretaries={this.props.folderHelp.connectedSecretariesList}
					/>
					<AddNurseHelpModal
						open={this.state.openAddNurseHelpModal}
						close={this.closeAddNurseHelpModal}
						createFolderHelp={this.createFolderHelpAndQuit}
						folder={this.state.addNurseHelpModalFolder}
						scans={[]}
						addScanOrdoToPrescription={this.addScanOrdoToPrescription}
						docs={[]}
						loadingScans={this.props.loadingScans}
						center={this.props.user.session.center.id}
						secretaries={this.props.folderHelp.connectedSecretariesList}
						tvsec={this.state.tvsec}
						deposit={this.state.deposit}
						deposit_places={this.props.deposit.places}
						deposit_samplers={this.props.deposit.samplers}
						documentTypeOptions={this.props.documentTypes?.list}
						getAllDocumentTypes={this.props.getAllDocumentTypes}
					/>
					<ExpressDepositModal
						open={this.state.expressDepositModal}
						close={this.closeExpressDepositModal}
						packs={this.props.analysisLibrary?.depositsPacks}
						createDepositExpress={this.props.postExpress}
						center={this.props.user.session.center.id}
					/>

					<CheckinModal
						open={this.state.checkinModal}
						close={this.closeCheckinModal}
						patient={this.state.checkinPatient}
						submit={this.props.postCheckin}
					/>
				</div>
			);
		}
	}
}

const mapStateToProps = (state) => {
	return {
		labAppointment: state.labAppointment,
		generalParameters: state.generalParameters,
		user: state.user,
		patients: state.patients,
		doctors: state.doctors,
		analysisLibrary: state.analysisLibrary,
		foldersOverview: state.foldersOverview,
		safeplace: state.safeplace,
		specialRegimes: state.specialRegimes,
		live: state.live.list,
		folderHelp: state.folderHelp,
		preregister: state.preregister,
		deposit: state.deposit,
		documentTypes: state.documentTypes,
		campaigns: state.campaigns,
		eprescriptionAgence: state.prescriptions?.eprescriptionAgence,
		invoices: state.patients?.invoices,
		casing: state.patients?.casing,
		center: state.centers?.center,
	};
};

const mapDispatchToProps = {
	getLabAppointmentsBetweenDates,
	postLabAppointment,
	patchLabAppointment,
	deleteLabAppointment,
	setFocusedFolders,
	searchPatientsMyLab,
	postPatient,
	getPrescriptionByBarcode,
	getMatchingPatient,
	patchPatient,
	postPatientMyLab,
	getDoctorExists,
	postDoctor,
	patchDoctor,
	postPrescription,
	postScanPrescription,
	bulkAnalysesPrescription,
	getMatchingAnalyses,
	getPatientExistingFolder,
	openFolder,
	setFilters,
	getPatientClosedFolders,
	setTab,
	getSafePlaceAppointment,
	getMpiPatientByMatricule,
	addPayment,
	useSafePlaceQR,
	cancelSafePlaceQR,
	getAllSpecialRegimes,
	getMyOpenedFolders,
	getFoldersWaitingTubes,
	getFoldersWaitingAliquots,
	getEPrescription,
	getAssignedToMeFolderHelp,
	doneFolderHelp,
	getPatientMyLab,
	qrSearch,
	sendPatientToDualScreen,
	editPIQuestionAnswer,
	createFolderHelp,
	setBusyBox,
	getSecretariesActive,
	qrPreregister,
	getPreregisterAppointment,
	postPreregisterForceStatusUrgent,
	cancelFolderHelp,
	notifyMeForPreregister,
	changePatient,
	searchFolderWithTube,
	getDepositPlaces,
	getDepositSamplers,
	getAllDocumentTypes,
	getCampaignResultByQrCode,
	qrSearchCampaign,
	searchDoctors,
	getAnalysesPacksForDeposits,
	postExpress,
	getInvoicesForPatient,
	getCasingForPatient,
	casingPaymentCancel,
	cancelCasingForPatient,
	exportCasingForPatient,
	resetInvoicesForPatient,
	associateCenterAppointmentWithFolder,
	resetLabAppointmentList,
	getAllPrescriptionScans,
	postCheckin,
	getCheckinsForPatient,
};

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(FoldersOverview)));
